import React, {useState} from "react";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import {useFittersData} from "../../../hooks/useFittersData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getFittersData} from "../../../state/selectors";
import NewFitter from "./NewFitter";
import FitterRow from "./FitterRow";
import Spinner from "react-spinner-material";
import {createSetDataFreshAction, createSetFittersDataAction} from "../../../actions/dataActions";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import LoadingSpinner from "../../Utils/Spinner";
import PaginationWrapper from "../../Utils/PaginationWrapper";


function FitterView(props){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);
    const loading = useFittersData({page, show_hide: true},dataFresh);
    const data = useSelector(getFittersData);

    if (!loading) {
        return (
            <LoadingSpinner/>
        );
    }

    const onChange = (e, index) => {
        let newResults = [...data.results];
        let newData = {...data, results: newResults};
        let newFitter = {...data.results[index]}
        newFitter[e.target.name] = e.target.value;
        newData.results[index] = newFitter
        dispatch(createSetFittersDataAction(newData));
    }

    const onSave = (setEditable, fitter) => {
        const conf = {
            url: 'api/fitter/'+ fitter.id,
            method: "put",
            data: fitter
        }
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            setEditable(false);
        }).catch(err => {
            toast.error("There was an error", {position: "top-right"});
        })
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <br/>
            <NewFitter/>
            <Box>
                <details>
                    <summary><Title>Fitters</Title></summary>
                <Table isFullwidth>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Hide</th>
                            <th></th>
                        </tr>
                    </thead>
                    {data.results.map((value,index) => (
                         <FitterRow
                             fitter={value}
                             onChange={onChange}
                             index={index}
                             onSave={onSave}
                         />
                    ))}
                </Table>
                <PaginationWrapper
                  setPage={setPage}
                  page={page}
                  dataCount={Math.ceil(data.count / 25)}
                />
                </details>
            </Box>
        </div>
    );

}
export default FitterView;